import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class YarnProperty1ReferenceService extends BaseReferenceService {
  constructor() {
    super('YarnProperty1Reference');
  }
}
